var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "portal-action-card" }, [
    _c("header", { staticClass: "action-card-header" }, [
      _c("div", { staticClass: "action-card-title" }, [
        _c(
          "span",
          { staticClass: "action-card-icon", attrs: { "aria-hidden": "true" } },
          [_c("portal-icon", { attrs: { name: _vm.icon, size: 21 } })],
          1
        ),
        _c("div", [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _c("span", { staticClass: "action-card-count" }, [
            _vm._v(_vm._s(_vm.count))
          ])
        ])
      ]),
      _c(
        "button",
        {
          staticClass: "action-card-open",
          attrs: { type: "button", "aria-label": _vm.title },
          on: {
            click: function($event) {
              return _vm.$emit("open")
            }
          }
        },
        [_c("portal-icon", { attrs: { name: "arrow-right", size: 19 } })],
        1
      )
    ]),
    _c("div", { staticClass: "action-card-list" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }